export default __webpack_public_path__ + "static/media/IMPORT_DATA_OP.1703c226.xlsx";